import _get from 'lodash/get'
import { Map } from 'immutable'
import { SET_RESOLVER_DATA } from './actions'
import { setPageSeo } from '../page/actions'
import { resolverMetaToPageSeo } from './metaToPageSeo'
import {
  RESOLVER_TYPE_SHARE,
  RESOLVER_TYPE_AI_SHARE,
  RESOLVER_TYPE_PORTAL,
} from './types'

const SEO_SKIP_TYPES = new Set([
  RESOLVER_TYPE_SHARE,
  RESOLVER_TYPE_AI_SHARE,
  RESOLVER_TYPE_PORTAL,
])

function getMetaFromData (data) {
  if (!data || !data.meta) {
    return null
  }
  const { meta } = data
  if (Map.isMap(meta)) {
    return meta.toJS()
  }
  return meta
}

// eslint-disable-next-line import/prefer-default-export
export function applyResolverMetaSeo ({ after }) {
  return after(SET_RESOLVER_DATA, async ({ dispatch, action, state }) => {
    const data = _get(action, ['payload', 'data'])
    const resolverType = _get(data, 'type')
    if (SEO_SKIP_TYPES.has(resolverType)) {
      return
    }
    const meta = getMetaFromData(data)
    if (!meta || !meta.title) {
      return
    }
    const location = state.resolver.get('location')
    if (!location || !location.pathname) {
      return
    }
    dispatch(setPageSeo(resolverMetaToPageSeo({
      meta,
      location: {
        pathname: location.pathname,
        search: location.search || '',
      },
    })))
  })
}
